import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './payment-return.css';

export default function PaymentSuccessPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [status, setStatus] = useState('loading');
  const [paymentStatus, setPaymentStatus] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    const verify = async () => {
      if (!sessionId) {
        setStatus('error');
        setError('Missing Stripe session. Please contact support.');
        return;
      }
      try {
        const rawApiBase = process.env.REACT_APP_API_BASE || '';
        const apiRoot = rawApiBase
          ? (rawApiBase.startsWith('http') ? rawApiBase : `https://${rawApiBase}`)
          : (typeof window !== 'undefined' ? window.location.origin : '');
        const apiBase = apiRoot.endsWith('/api')
          ? apiRoot
          : `${apiRoot.replace(/\/$/, '')}/api`;
        const statusUrl = new URL(
          `stripe/session-status?session_id=${encodeURIComponent(sessionId)}`,
          `${apiBase.replace(/\/$/, '')}/`
        ).toString();
        const res = await fetch(statusUrl);
        const payload = await res.json();
        if (!res.ok) throw new Error(payload?.error || 'Unable to verify payment.');
        if (payload?.payment_status === 'paid' || payload?.payment_status === 'trialing') {
          try {
            localStorage.setItem('payment_complete', 'true');
            localStorage.setItem('payment_session_id', sessionId);
          } catch (_) {}
          if (mounted) {
            setPaymentStatus(payload?.payment_status || '');
            setStatus('success');
            const timer = setTimeout(() => navigate('/onboarding'), 1200);
            return () => clearTimeout(timer);
          }
        } else {
          setStatus('error');
          setError('Payment not confirmed yet. Please refresh in a moment.');
        }
      } catch (err) {
        setStatus('error');
        setError(err?.message || 'Unable to verify payment.');
      }
    };

    verify();
    return () => { mounted = false; };
  }, [navigate, sessionId]);

  return (
    <main className="payment-return-page">
      <div className="payment-card">
        {status === 'loading' && (
          <>
            <div className="payment-spinner" aria-label="Loading" />
            <h1>Confirming payment</h1>
            <p>Hang tight while we verify your payment.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="payment-icon success" aria-hidden>&#10003;</div>
            <h1>{paymentStatus === 'trialing' ? 'Trial started' : 'Payment confirmed'}</h1>
            <p>
              {paymentStatus === 'trialing'
                ? 'Your 7-day free trial is active. Let\'s dial in your goals so we can build a plan that actually works for you.'
                : "Let's dial in your goals, experience, and preferences so we can build a plan that actually works for you."}
            </p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="payment-icon warning">!</div>
            <h1>Payment verification pending</h1>
            <p>{error || 'We could not confirm your payment yet.'}</p>
            <button className="cta-btn" type="button" onClick={() => navigate('/select-plan')}>
              Back to packages
            </button>
          </>
        )}
      </div>
    </main>
  );
}
